import { render } from "./LegalAcceptanceModal.vue?vue&type=template&id=465caa3d&scoped=true"
import script from "./LegalAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./LegalAcceptanceModal.vue?vue&type=script&lang=js"

import "./LegalAcceptanceModal.vue?vue&type=style&index=0&id=465caa3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465caa3d"]])

export default __exports__